import * as dates from 'react-big-calendar/lib/utils/dates';
import { eventLevels } from 'react-big-calendar/lib/utils/eventLevels';
import findIndex from 'lodash/findIndex';

let isSegmentInSlot = (seg, slot) => seg.left <= slot && seg.right >= slot;

function endOfRange(dateRange, unit = 'day') {
  return {
    first: dateRange[0],
    last: dateRange[dateRange.length - 1],
  };
}

function daysDiff(dateA, dateB, unit) {
  const milliInDay = 1000 * 60 * 60 * 24;

  // the .round() handles an edge case
  // with DST where the total won't be exact
  // since one day in the range may be shorter/longer by an hour
  return Math.round(Math.abs(+dates.startOf(dateA, unit) / milliInDay - +dates.endOf(dateB, unit) / milliInDay));
}

export function getSlotMetrics() {
  return (options) => {
    const { range, events, maxRows, minRows, accessors } = options;
    let { first, last } = endOfRange(range);

    let segments = events.map((evt) => eventSegments(evt, range, accessors));

    let { levels, extra } = eventLevels(segments, Math.max(maxRows - 1, 1));
    while (levels.length < minRows) levels.push([]);

    return {
      first,
      last,

      levels,
      extra,
      range,
      slots: range.length,

      clone(args) {
        const metrics = getSlotMetrics();
        return metrics({ ...options, ...args });
      },

      getDateForSlot(slotNumber) {
        return range[slotNumber];
      },

      getSlotForDate(date) {
        return range.find((r) => dates.eq(r, date, 'day'));
      },

      getEventsForSlot(slot) {
        return segments.filter((seg) => isSegmentInSlot(seg, slot)).map((seg) => seg.event);
      },

      continuesPrior(event) {
        return dates.lt(accessors.start(event), first, 'day');
      },

      continuesAfter(event) {
        const eventEnd = accessors.end(event);
        const singleDayDuration = dates.eq(accessors.start(event), eventEnd, 'minutes');

        return singleDayDuration ? dates.gte(eventEnd, last, 'minutes') : dates.gt(eventEnd, last, 'minutes');
      },
    };
  };
}

function eventSegments(event, range, accessors) {
  let { first, last } = endOfRange(range);

  let slots = daysDiff(first, last, 'day');
  let start = dates.max(dates.startOf(accessors.start(event), 'day'), first);
  let end = dates.min(dates.ceil(accessors.end(event), 'day'), last);

  let padding = findIndex(range, (x) => dates.eq(x, start, 'day'));
  let span = daysDiff(start, end, 'day');

  span = Math.min(span, slots);
  span = Math.max(span, 1);

  return {
    event,
    span: span,
    left: padding + 1,
    right: Math.max(padding + span, 1),
  };
}
